// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yq-1";
export var printerIcon = "_yq-0";